import { render, staticRenderFns } from "./HomePageConfiguration.vue?vue&type=template&id=036208c5&"
import script from "./HomePageConfiguration.vue?vue&type=script&lang=js&"
export * from "./HomePageConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports